import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledTaskTips = styled.span`
  font-size: 2.4rem;
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledTaskTipsIcon = styled(FontAwesomeIcon)`
  font-size: 2.4rem;
  margin-right: 0.5rem;
  color: ${({ theme }) => theme.colors.info.main};
`;

export const StyledTipHeading = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  margin-bottom: 0.8rem;
`;

export const StyledTipDescription = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledUnorderedList = styled.ul`
  list-style-type: disc;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  margin-left: 2rem;
`;

export const StyledTaskTipContainer = styled.div`
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
`;
